module.exports = __webpack_public_path__ + "img/2018-12-16-2.5b9f92be.jpeg";